import { ResponseError } from 'aos-helpers/src/helpers/error/ResponseError'

import { BaseRestService } from '../BaseRestService'

const incorrectStatusesResponseInterceptor = async (r: Response): Promise<Response> => {
    if (r.ok) {
        return r
    }

    let errorPayload: any
    try {
        errorPayload = await r.clone().json()
    } catch {
        errorPayload = {
            message: await r
                .clone()
                .text()
                .catch(() => ''),
            status: 'error',
            httpStatus: r.status,
            timestamp: new Date().toISOString(),
        }
    }

    throw new ResponseError(r, errorPayload)
}
export const registerIncorrectStatusesResponseInterceptor = () => {
    BaseRestService.responseInterceptors.push(incorrectStatusesResponseInterceptor)
}
